<template>

</template>

<script>
export default {
  name: "InformationScreen"
}
</script>

<style scoped>

</style>
